'use client'

import { useEffect,useLayoutEffect } from 'react'

/**
 * Enhanced `useEffect` to ensure that it works on both client and server side
 */
export const useEnhancedEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect
